import React from "react";
import { ToastContainer } from "react-toastify";
import ViewTestimonial from "../../components/Settings/Testimonial/ViewTestimonial";

export const ViewTestimonialPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewTestimonial />
        </div>
      </div>
    </div>
  );
};
